import React from 'react';
import PropTypes from 'prop-types';

import CertificationBadge from 'components/CertificationBadge';
import colors from 'constants/colors';

const CertificationPathFooter = ({
  certification,
  isComplete,
  hasHiddenContents,
  toggleCertificateModal,
  showCertificateModalInPreview,
}) => {
  const hasNoHiddenContentsAndIsComplete = !hasHiddenContents && isComplete;
  return (
    <div className="CertificationPathFooter d-f fd-c ai-c">
      <div className="mb-24 ff-ss fz-16 fw-b c-gray-darker ta-c">
        {hasNoHiddenContentsAndIsComplete
          ? t('paths.certification_footer.complete')
          : t('paths.certification_footer.incomplete')}
      </div>
      <CertificationBadge
        iconName={certification.iconName}
        height={72}
        width={57}
        foregroundColor={
          hasNoHiddenContentsAndIsComplete
            ? certification.foregroundColor
            : colors.GRAY_DARK
        }
        backgroundColor={
          hasNoHiddenContentsAndIsComplete
            ? certification.backgroundColor
            : colors.GRAY_LIGHT
        }
        image={certification.image}
      />
      {hasNoHiddenContentsAndIsComplete && showCertificateModalInPreview && (
        <button
          type="button"
          className="u-resetBtn h-td-u mt-8 c-brand-blue fz-bigger"
          onClick={toggleCertificateModal}
        >
          {t('certifications.certificate.view_certificate')}
        </button>
      )}
    </div>
  );
};

CertificationPathFooter.propTypes = {
  certification: PropTypes.shape({
    iconName: PropTypes.string,
    foregroundColor: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  isComplete: PropTypes.bool.isRequired,
  hasHiddenContents: PropTypes.bool.isRequired,
};

export default CertificationPathFooter;
